
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import Icon from '@/components/UI/Icon.vue';

@Component({
  components: {
    Icon,
  },
})
export default class ReloadButton extends Vue {
  @Prop({ type: Boolean, required: false, default: false }) public loading!: boolean;
  @Prop({ type: Boolean, required: false, default: false }) public disabled!: boolean;
}
